import React, { useState } from "react";
import PropTypes from "prop-types";
import TopNav from "../../commonUI/TopHeader/TopHeader";
import withNavigate from "../withNavigate";
import DiscountCodesTab from "./DiscountCodesTab";
import CampaignsTab from "./CampaignsTab";
import { Box, Button, Drawer } from "@mui/material";
import CreateDiscount from "./CreateDiscount";
import CreateCampaign from "./CreateCampaign";
import ConfirmDialog from "../../Modal/ConfirmDialog";
import { MOCK_DISCOUNTS } from "../../../config/constants";

const Discount = ({ userDetails, navigate }) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [selectedDiscounts, setSelectedDiscounts] = useState([]);
  const [discounts, setDiscounts] = useState(MOCK_DISCOUNTS);
  const [activeTab, setActiveTab] = useState("discounts");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const toggleDrawer =
    (anchor, open, view = null, campaign = null) =>
    (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });

      if (open) {
        setCurrentView(view);
        if (campaign) {
          setSelectedCampaign(campaign);
        } else {
          setSelectedCampaign(null);
        }
      }
    };

  const handleDeleteSelected = () => {
    if (selectedDiscounts.length === 0) return;
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = () => {
    setDiscounts(discounts.filter((d) => !selectedDiscounts.includes(d._id)));
    setSelectedDiscounts([]);
    setShowDeleteConfirm(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
  };
  return (
    <>
      <header className="d-flex align-items-center justify-content-between">
        <TopNav title="Discounts" />
        <span className="d-flex align-items-center gap-4">
          {activeTab === "discounts" && selectedDiscounts.length > 0 && (
            <Button
              type="button"
              className="btn btn-danger"
              onClick={handleDeleteSelected}
              sx={{
                backgroundColor: "#dc3545",
                "&:hover": {
                  backgroundColor: "#c82333",
                },
              }}
            >
              Delete Selected
            </Button>
          )}
          {activeTab === "discounts" && ["right"].map((anchor) => (
            <React.Fragment key={anchor}>
              <Button
                type="button"
                className="btn btn-success"
                onClick={toggleDrawer(anchor, true, "create")}
                sx={{
                  backgroundColor: "#229954",
                  marginLeft: "6px",
                  "&:hover": {
                    backgroundColor: "#1e8449",
                  },
                }}
              >
                + Create Discount
              </Button>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                  ModalProps={{
                    BackdropProps: {
                      style: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                    },
                  }}
                  sx={{
                    boxShadow: "none",
                    "& .MuiDrawer-paper": { boxShadow: "none" },
                  }}
                >
                  <Box
                    sx={{ width: 600 }}
                    role="presentation"
                    onClick={(event) => event.stopPropagation()}
                    onKeyDown={(event) => event.stopPropagation()}
                  >
                    <CreateDiscount
                      view={currentView}
                      discount={selectedDiscount}
                      onClose={toggleDrawer(anchor, false)}
                    />
                  </Box>
                </Drawer>
              </React.Fragment>
            ))}
          {activeTab === "campaigns" && ["right"].map((anchor) => (
            <React.Fragment key={anchor}>
              <Button
                type="button"
                className="btn btn-success"
                onClick={toggleDrawer(anchor, true, "create")}
                sx={{
                  backgroundColor: "#229954",
                  "&:hover": {
                    backgroundColor: "#1e8449",
                  },
                }}
              >
                + Create Campaign
              </Button>
              <Drawer
                anchor={anchor}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
                ModalProps={{
                  BackdropProps: {
                    style: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                  },
                }}
                sx={{
                  boxShadow: "none",
                  "& .MuiDrawer-paper": { boxShadow: "none" },
                }}
              >
                <Box
                  sx={{ width: 600 }}
                  role="presentation"
                  onClick={(event) => event.stopPropagation()}
                  onKeyDown={(event) => event.stopPropagation()}
                >
                  <CreateCampaign
                    view={currentView}
                    campaign={selectedCampaign}
                    onClose={toggleDrawer(anchor, false)}
                  />
                </Box>
              </Drawer>
            </React.Fragment>
          ))}
        </span>
      </header>
      <div className="global-body">
        <div className="global-body-container">
          {/* Tabs Navigation */}
          <div className="custom-tabs mt-0">
            <div
              className={`tab-item ${activeTab === "discounts" ? "active" : ""}`}
              onClick={() => setActiveTab("discounts")}
            >
              Discount codes
              <span className="badge">6</span>
            </div>
            <div
              className={`tab-item ${activeTab === "campaigns" ? "active" : ""}`}
              onClick={() => setActiveTab("campaigns")}
            >
              Campaigns
              <span className="badge">3</span>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === "discounts" && (
            <DiscountCodesTab
              userDetails={userDetails}
              navigate={navigate}
              selectedDiscounts={selectedDiscounts}
              setSelectedDiscounts={setSelectedDiscounts}
              discounts={discounts}
              setDiscounts={setDiscounts}
            />
          )}
          {activeTab === "campaigns" && (
            <CampaignsTab userDetails={userDetails} navigate={navigate} />
          )}
        </div>
      </div>

      <ConfirmDialog
        open={showDeleteConfirm}
        title="Delete Selected Discounts"
        message={`Are you sure you want to delete ${selectedDiscounts.length} discount${selectedDiscounts.length > 1 ? "s" : ""}?`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="Delete"
        cancelText="Cancel"
        variant="danger"
      />
    </>
  );
};

Discount.propTypes = {
  userDetails: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default withNavigate(Discount);
